












































































































































import LocalForage from "localforage";
import { Component, Vue } from "vue-property-decorator";
import { namespace, State } from "vuex-class";
import { Settings } from "@/store/settings";
import { Mode } from "@/types";

const SettingsStore = namespace("settings");

@Component
export default class SettingsView extends Vue {
  private analysis: string = "";

  private encode: string = "";

  private customEncode: string = "";

  private snomed: string = "";

  private verify: string = "";

  private search: string = "";

  private msa: string = "";

  private lien: string = "";

  private tokenizer: string = "";

  private textractor: string = "";

  private readonly customized: boolean =
    process.env.VUE_APP_CUSTOM_ENDPOINTS_ENABLED === "1";

  @State("mode")
  private mode!: Mode;

  @SettingsStore.State("current")
  private settings!: Settings;

  @SettingsStore.Action("set")
  private set!: (params: {
    key:
      | "analysis"
      | "encode"
      | "customEncode"
      | "snomed"
      | "msa"
      | "lien"
      | "tokenizer"
      | "search"
      | "verify"
      | "textractor"
      | "showAllDuplicates";
    value: any;
  }) => void;

  @SettingsStore.Action("reset")
  private reset!: () => void;

  update() {
    this.analysis = this.settings.endpoints.analysis;
    this.encode = this.settings.endpoints.encode;
    this.customEncode = this.settings.endpoints.customEncode;
    this.snomed = this.settings.endpoints.snomed;
    this.verify = this.settings.endpoints.verify;
    this.search = this.settings.endpoints.search;
    this.msa = this.settings.endpoints.msa;
    this.lien = this.settings.endpoints.lien;
    this.tokenizer = this.settings.endpoints.tokenizer;
    this.textractor = this.settings.endpoints.textractor;
  }

  mounted() {
    this.update();
  }

  commit() {
    this.set({ key: "analysis", value: this.analysis });
    this.set({ key: "encode", value: this.encode });
    this.set({ key: "customEncode", value: this.customEncode });
    this.set({ key: "snomed", value: this.snomed });
    this.set({ key: "verify", value: this.verify });
    this.set({ key: "search", value: this.search });
    this.set({ key: "msa", value: this.msa });
    this.set({ key: "lien", value: this.lien });
    this.set({ key: "tokenizer", value: this.tokenizer });
    this.set({ key: "textractor", value: this.textractor });
  }

  async clearCache() {
    await LocalForage.removeItem("DOCUMENT_CACHE");
    await LocalForage.removeItem("LIEN_CACHE");
  }

  toggleShowAllDuplicates() {
    this.set({
      key: "showAllDuplicates",
      value: !this.settings.showAllDuplicates
    });
  }
}
